import { msg } from '@lingui/core/macro'
import type { NavItemConfig } from 'features/navbar/navConfig'
import { SelectedTab } from 'features/navbar/types'
import { Database } from 'lucide-react'

const CMMS_NAV_CONFIG: NavItemConfig = {
  to: '/documents/cmms',
  search: (siteId, orgId) => ({ siteId, orgId }),
  icon: Database,
  label: msg`CMMS Explorer`,
}

export function withCmmsExplorerNavItem(
  items: Array<[SelectedTab, NavItemConfig]>,
  enabled: boolean
): Array<[SelectedTab, NavItemConfig]> {
  if (!enabled) return items
  const documentsIndex = items.findIndex(
    ([key]) => key === SelectedTab.Documents
  )
  const index = documentsIndex < 0 ? 0 : documentsIndex + 1
  const result = [...items]
  result.splice(index, 0, [SelectedTab.CmmsExplorer, CMMS_NAV_CONFIG])
  return result
}
